var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"25px"}},[_c('div',{staticClass:"col-md-6 offset-md-3"},[_c('div',{staticClass:"callout callout-info"},[_c('h5',[_vm._v("Müşteri Arama!")]),_vm._v(" "),_c('p',[_vm._v("Müşteri ID ve site ile arama yapın.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f52ad1c2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/Main.vue
// module id = 219
// module chunks = 0